var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowUpRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 5V15C20 15.552 19.553 16 19 16C18.447 16 18 15.552 18 15V7.41406L6.70707 18.707C6.51207 18.902 6.25604 19 6.00004 19C5.74404 19 5.48801 18.902 5.29301 18.707C4.90201 18.316 4.90201 17.684 5.29301 17.293L16.586 6H9.00004C8.44704 6 8.00004 5.552 8.00004 5C8.00004 4.448 8.44704 4 9.00004 4H19C19.13 4 19.2601 4.0269 19.3821 4.0769C19.6271 4.1779 19.8221 4.37292 19.9231 4.61792C19.9741 4.73992 20 4.87 20 5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUpRight);
export default __webpack_public_path__ + "static/media/arrow-up-right.63c72991e5c87440a4e045eafaabd8d0.svg";
export { ForwardRef as ReactComponent };